module.exports = __webpack_public_path__ + "static/img/pencil.3095ecca.svg";